import Header from '../../__Layout/Header';
import React  from "react";

export default function TutorSupport() {
   
    return (
        <div className="Home">
            <Header />
            <main id="main" className="main">
            <div className="pagetitle">
            <h1>Tutor Support</h1>
            <nav>
                <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="index.html">Home</a></li>
                <li className="breadcrumb-item active">Tutor Support</li>
                </ol>
            </nav>
            </div>
            <section className="section ContactUs">
            <div className="row">
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col-xxl-12 col-md-12">
                            <div className="card info-card sales-card">
                                <div className="card-body">
                                <h5 className="card-title">Tutor Support</h5>
                                <div className="d-flex align-items-center">
                                    <div className="ps-3">
                                           <table className="table">   
                                                <tbody>
                                                    <tr>
                                                        <td><a href="https://api.whatsapp.com/send?phone=971507766198" target="_blank" className='btn btn-success btn-block'>Contact Tutor</a></td> 
                                                    </tr>
                                                    <tr>
                                                    <td><a href="https://api.whatsapp.com/send?phone=971557883554" target="_blank" className='btn btn-success btn-block'>Contact Admin</a></td> 

                                                    </tr>
                
                                                </tbody>
                                            </table> 
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            </section>
           </main>
        </div>
    );
}